module.exports = __webpack_public_path__ + "static/media/Helga.3d55d6ca.md";